<template>
  <div :class="c()">
    <div>{{ text }}</div>
    <answer-options
      v-if="isOptionsQuestion"
      v-model="answer"
      :options="options"
      :name="questionId"
    />
    <answer-text
      v-else-if="isStringQuestion"
      v-model="answer"
    />
  </div>
</template>

<script>
import {cn} from '@/app/js/classname'
import AnswerOptions from '@/app/vue/survey/answer/answer-options.vue'
import AnswerText from '@/app/vue/survey/answer/answer-text.vue'

const c = cn('survey-field')

export default {
  name: 'SurveyField',
  components: {AnswerOptions, AnswerText},
  inheritAttrs: false,
  props: {
    questionId: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'string'
    },
    text: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: null
    }
  },
  emits: ['answer'],
  data() {
    return {
      answer: ''
    }
  },
  computed: {
    isStringQuestion() {
      return this.type === 'string'
    },
    isOptionsQuestion() {
      return this.type === 'options'
    }
  },
  watch: {
    answer() {
      this.$emit('answer', {
        question: this.text,
        answer: this.answer
      })
    },
    questionId() {
      this.answer = ''
    }
  },
  methods: {
    c,
  }
}
</script>

<style lang="scss">
.survey-field {
  display: flex;
  gap: 16px;
  flex-direction: column;
  color: #000;
  font-weight: 600;
  font-size: 16px;
}
</style>
